/* Sportedix — predictive search (Shopify /search/suggest + Section Rendering API) */
class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-results]');
    if (!this.input || !this.results || this.dataset.enabled === 'false') return;
    this.cache = new Map();
    this.input.addEventListener('input', this.debounce(() => this.onInput(), 280));
    this.input.addEventListener('keydown', (e) => this.onKey(e));
    this.input.form.addEventListener('submit', (e) => {
      const active = this.results.querySelector('[aria-selected="true"] a, a[aria-selected="true"]');
      if (active) { e.preventDefault(); active.click(); }
    });
  }
  debounce(fn, wait) { let t; return () => { clearTimeout(t); t = setTimeout(fn, wait); }; }
  get term() { return this.input.value.trim(); }
  async onInput() {
    const q = this.term;
    if (!q.length) { this.close(); return; }
    if (this.cache.has(q)) { this.render(this.cache.get(q)); return; }
    this.abort && this.abort.abort();
    this.abort = new AbortController();
    const root = (window.Sportedix && window.Sportedix.routes.predictive_search) || '/search/suggest';
    const params = new URLSearchParams({
      q,
      section_id: 'predictive-search',
      'resources[type]': 'product,collection,article,page,query',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
    });
    try {
      const res = await fetch(`${root}?${params.toString()}`, { signal: this.abort.signal });
      if (!res.ok) throw new Error(res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-predictive-content]');
      const markup = content ? content.outerHTML : '';
      this.cache.set(q, markup);
      if (q === this.term) this.render(markup);
    } catch (e) {
      if (e.name !== 'AbortError') this.close();
    }
  }
  render(markup) {
    this.results.innerHTML = markup;
    if (this.dataset.showPrice === 'false') this.results.querySelectorAll('[data-price]').forEach((el) => el.remove());
    this.input.setAttribute('aria-expanded', markup ? 'true' : 'false');
    this.results.setAttribute('role', 'listbox');
    this.index = -1;
  }
  close() {
    this.results.innerHTML = '';
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  }
  options() { return Array.from(this.results.querySelectorAll('[role="option"]')); }
  onKey(e) {
    const opts = this.options();
    if (!opts.length || !['ArrowDown', 'ArrowUp'].includes(e.key)) return;
    e.preventDefault();
    this.index = typeof this.index === 'number' ? this.index : -1;
    this.index = e.key === 'ArrowDown' ? (this.index + 1) % opts.length : (this.index - 1 + opts.length) % opts.length;
    opts.forEach((o, i) => o.setAttribute('aria-selected', i === this.index ? 'true' : 'false'));
    const active = opts[this.index];
    this.input.setAttribute('aria-activedescendant', active.id);
    active.scrollIntoView({ block: 'nearest' });
  }
}
customElements.define('predictive-search', PredictiveSearch);
